import type { GetSessionInfoResponse } from "@/backend/natsstubs/almsync/common/models";
import type { GetServerInfoResponse } from "@/backend/natsstubs/piserver/models";
import type { RandomDataResponse } from "@/backend/natsstubs/status/models";

import type {
  ServerAlmInfo,
  ServerAlmType,
  ServerInfo,
  ServerStatusWithData,
} from "../serverModel";

/**
 * All-null ALM fields mean the session has no ALM connection (a normal
 * state); they map to absent keys so `initSession`'s `!almType` branch keeps
 * working exactly as with the legacy WAMP nulls object.
 */
export function mapApiAlmSessionInfo(info: GetSessionInfoResponse): ServerAlmInfo {
  return {
    ...(info.almConnectionType !== undefined &&
      info.almConnectionType !== null && {
        alm_connection_type: info.almConnectionType as ServerAlmType,
      }),
    ...(info.syncSessionId !== undefined &&
      info.syncSessionId !== null && { sync_session_id: info.syncSessionId }),
    ...(info.almConnectionId !== undefined &&
      info.almConnectionId !== null && { alm_connection_id: info.almConnectionId }),
    disable_delete: info.disableDelete,
  };
}

// The stub types the API versions as strings; legacy consumers treat them as
// numbers (serverTime, the http health check's truthiness probe).
export function mapApiServerInfo(info: GetServerInfoResponse): ServerInfo {
  return {
    major_API_version: Number(info.majorAPIVersion),
    minor_API_version: Number(info.minorAPIVersion),
    time: info.time,
  };
}

export function mapApiStatusData(data: RandomDataResponse): ServerStatusWithData {
  return {
    timestamp_in: data.timestampIn,
    timestamp_out: data.timestampOut,
    data: data.data,
  };
}
